export var ToolName;
(function (ToolName) {
    // Frontend tools (executed by UI)
    ToolName["CreateWidget"] = "createWidget";
    ToolName["ConnectWidgets"] = "connectWidgets";
    ToolName["UpdateWidget"] = "updateWidget";
    ToolName["UpdateWidgetInputs"] = "updateWidgetInputs";
    ToolName["DeleteWidget"] = "deleteWidget";
    ToolName["ApplyCanvasPlan"] = "applyCanvasPlan";
    ToolName["CreateDiscoveryNode"] = "createDiscoveryNode";
    ToolName["NavigateToSubcanvas"] = "navigateToSubcanvas";
    ToolName["Answer"] = "answer";
    // Backend tools (executed server-side)
    ToolName["AskFinancialAnalyst"] = "askFinancialAnalyst";
    ToolName["AskDataSteward"] = "askDataSteward";
    ToolName["FetchMarketData"] = "fetchMarketData";
    ToolName["SearchSymbols"] = "searchSymbols";
    ToolName["CalculatePortfolioRisk"] = "calculatePortfolioRisk";
    ToolName["CalculateTechnicals"] = "calculateTechnicals";
    ToolName["AnalyzeMarketSentiment"] = "analyzeMarketSentiment";
    ToolName["GetMarketSnapshot"] = "getMarketSnapshot";
    // Profiles and macros
    ToolName["LoadProfileWorkspace"] = "loadProfileWorkspace";
    ToolName["LoadMarketOverviewWorkspace"] = "loadMarketOverviewWorkspace";
    ToolName["SearchOrCreateProfile"] = "searchOrCreateProfile";
    ToolName["RefreshProfileResearch"] = "refreshProfileResearch";
    ToolName["GetProfileModule"] = "getProfileModule";
    // Utility/internal
    ToolName["BatchBackend"] = "batchBackend";
    ToolName["Reflect"] = "reflect";
    ToolName["TodoStart"] = "todoStart";
    ToolName["TodoAdd"] = "todoAdd";
    ToolName["TodoDone"] = "todoDone";
    ToolName["TodoList"] = "todoList";
    ToolName["TodoClose"] = "todoClose";
})(ToolName || (ToolName = {}));
const BACKEND_STATIC = new Set([
    ToolName.AskFinancialAnalyst,
    ToolName.AskDataSteward,
    ToolName.FetchMarketData,
    ToolName.SearchSymbols,
    ToolName.CalculatePortfolioRisk,
    ToolName.CalculateTechnicals,
    ToolName.AnalyzeMarketSentiment,
    ToolName.GetMarketSnapshot,
    ToolName.LoadProfileWorkspace,
    ToolName.LoadMarketOverviewWorkspace,
    ToolName.SearchOrCreateProfile,
    ToolName.RefreshProfileResearch,
    ToolName.GetProfileModule,
    ToolName.BatchBackend,
    ToolName.Reflect,
    ToolName.TodoStart,
    ToolName.TodoAdd,
    ToolName.TodoDone,
    ToolName.TodoList,
    ToolName.TodoClose,
]);
export function isBackendTool(toolName) {
    return BACKEND_STATIC.has(toolName);
}
